import {
    StanFloatingMenu,
    StanFloatingMenuHandle,
} from '@/components/core-components/StanDropdown/FloatingMenu/StanFloatingMenu';
import { cn } from '@/lib';
import { HTMLAttributes, useRef } from 'react';
import { tv, VariantProps } from 'tailwind-variants';
import { Button } from './Button';
import { Icon } from './Icon';

export type Props = {
    unsavedChanges: boolean;
    revertToLastPublished: () => void;
} & VariantProps<typeof buttonVariants> &
    HTMLAttributes<HTMLButtonElement>;

const buttonVariants = tv({
    base: 'leading-none text-semantic-fg-on-contrast leading-[1.5] whitespace-nowrap rounded-full px-3 py-2 flex cursor-pointer flex-nowrap items-center gap-1 text-inverse',
    variants: {
        variant: {
            published: 'bg-success-main hover:bg-success-main/85 pointer-events-none pr-4',
            pending: 'bg-brand-main hover:bg-brand-main/85',
        },
    },
});

export const Publish = ({ variant, revertToLastPublished, className, unsavedChanges, ...rest }: Props) => {
    const triggerRef = useRef<HTMLButtonElement>(null);
    const menuRef = useRef<StanFloatingMenuHandle>(null);

    return (
        <div>
            <div className='flex items-center gap-[1px] text-sm font-bold'>
                <button
                    className={buttonVariants({
                        variant,
                        class: cn(className, variant === 'pending' && 'rounded-r-0'),
                    })}
                    {...rest}
                >
                    {variant === 'published' && <Icon name='send' />}
                    {variant === 'published' ? 'Published' : 'Save'}
                </button>
                {unsavedChanges && (
                    <StanFloatingMenu
                        id='profile-menu'
                        name='profile-menu'
                        trigger={
                            <button
                                className={buttonVariants({
                                    variant,
                                    class: cn('rounded-l-0 self-stretch', className),
                                })}
                                ref={triggerRef}
                            >
                                <Icon name='chevron' className='inline-flex -rotate-90 text-[16px] transition-all' />
                            </button>
                        }
                        placement='bottom-end'
                        ref={menuRef}
                    >
                        <div className='w-full max-w-100'>
                            <ul className='flex w-full transform flex-col overflow-hidden whitespace-nowrap'>
                                <li>
                                    <Button
                                        onClick={() => {
                                            menuRef.current?.setMenu(false);
                                            revertToLastPublished();
                                        }}
                                        icon={<Icon name='revert' />}
                                    >
                                        Revert to Last Published
                                    </Button>
                                </li>
                            </ul>
                        </div>
                    </StanFloatingMenu>
                )}
            </div>
        </div>
    );
};
